import {ChangeDetectorRef, Component, forwardRef, OnInit} from '@angular/core';
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {Vehicle} from "../../model/vehicle.type";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SessionActions} from "../../../shared/actions/session.actions";

@Component({
  selector: 'vb-vehicle-form',
  templateUrl: './vehicle-form.component.html',
  styleUrls: ['./vehicle-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => VehicleFormComponent)}]
})
export class VehicleFormComponent extends AbstractVisbosControl<Vehicle, FormGroup> implements OnInit {

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  buildControlContent(values?: Vehicle): FormGroup {
    return VehicleFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder): FormGroup {
    return fb.group({
      cuid: [null],
      license_plate: [null, Validators.required],
      administration_unit_id: [null, Validators.required],
      account_id: [null]
    });
  }

  public setDefaultValues(item?: Vehicle): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      license_plate: this.setValue(item, 'license_plate')
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/fleet/components/vehicle-form/vehicle-form.component.ts